export default "<div>\n    <input matInput [(ngModel)]=\"email\" (keyup)=\"onChange()\" placeholder=\"{{'FILTERS.BY_EMAIL.TITLE' | translate}}\">\n</div>"